import Logger from '@diziner/Logger';
export var SwipeEventDirection;
(function (SwipeEventDirection) {
    SwipeEventDirection["top"] = "top";
    SwipeEventDirection["right"] = "right";
    SwipeEventDirection["down"] = "down";
    SwipeEventDirection["left"] = "left";
})(SwipeEventDirection || (SwipeEventDirection = {}));
/* eslint-disable @typescript-eslint/ban-ts-comment */
export class Swipe {
    constructor(element = null) {
        this._yDown = 0;
        this._xDown = 0;
        this._yDiff = 0;
        this._xDiff = 0;
        this._timeDown = null;
        this._element = null;
        this._startElement = null;
        if (element !== null) {
            this._element = element;
        }
        else {
            this._element = document;
        }
        // @ts-ignore
        this._element.addEventListener('touchstart', this.handleTouchStart, false);
        // @ts-ignore
        this._element.addEventListener('touchmove', this.handleTouchMove, false);
        // @ts-ignore
        this._element.addEventListener('touchend', this.handleTouchEnd, false);
    }
    static get invalidTargets() {
        return this._invalidTargets;
    }
    static addInvalidTarget(target) {
        if (!Swipe._invalidTargets.includes(target)) {
            Swipe._invalidTargets.push(target);
        }
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    handleTouchStart(event) {
        Logger.instance.debug(event);
        this._startElement = event.target;
        Swipe._invalidTargets.forEach(function (invalidTarget) {
            if (this._startElement?.closest(invalidTarget) !== null) {
                this._startElement = null;
                return;
            }
        }.bind(this));
        this._timeDown = Date.now();
        this._xDown = event.touches[0].clientX;
        this._yDown = event.touches[0].clientY;
        this._xDiff = 0;
        this._yDiff = 0;
    }
    handleTouchMove(event) {
        if (!this._xDown || !this._yDown) {
            return;
        }
        this._xDiff = this._xDown - event.touches[0].clientX;
        this._yDiff = this._yDown - event.touches[0].clientY;
    }
    handleTouchEnd(event) {
        Logger.instance.debug(event);
        if (this._startElement !== event.target || this._timeDown === null) {
            Logger.instance.info('target not touching start');
            return;
        }
        let direction = null;
        const timeDiff = Date.now() - this._timeDown;
        if (Math.abs(this._xDiff) > Math.abs(this._yDiff)
            && Math.abs(this._xDiff) > Swipe.swipeThreshold
            && timeDiff < Swipe.swipeTimeout) {
            if (this._xDiff > 0) {
                direction = SwipeEventDirection.left;
            }
            else {
                direction = SwipeEventDirection.right;
            }
        }
        else if (Math.abs(this._yDiff) > Swipe.swipeThreshold
            && timeDiff < Swipe.swipeTimeout) {
            if (this._yDiff > 0) {
                direction = SwipeEventDirection.top;
            }
            else {
                direction = SwipeEventDirection.down;
            }
        }
        if (direction === null) {
            return;
        }
        const eventData = {
            direction: direction,
            xStart: this._xDown,
            xEnd: event.changedTouches[0].clientX || -1,
            yStart: this._yDown,
            yEnd: event.changedTouches[0].clientY || -1,
        };
        this._startElement?.dispatchEvent((new CustomEvent('swiped', {
            bubbles: true,
            cancelable: true,
            detail: eventData,
        })));
    }
}
Swipe.swipeThreshold = 20;
Swipe.swipeTimeout = 500;
Swipe._invalidTargets = [
    '.dialog-widget',
];
export default Swipe;
